// Copyright (c) 2017 Deere & Company

import sharedActions from '../shared/actions-list';

export default Object.freeze({
    ...sharedActions,
    FILTER_PIP_SEARCH_RESULTS: 'FILTER_PIP_SEARCH_RESULTS',
    FILTER_SEARCH_RESULTS: 'FILTER_SEARCH_RESULTS',
    INITIALIZE_LABOR_ADDITIVE_PIP_PRODUCTS_SHOW_EXCLUDED_FACET_ITEM: 'INITIALIZE_LABOR_ADDITIVE_PIP_PRODUCTS_SHOW_EXCLUDED_FACET_ITEM',
    READ_LABOR_ADDITIVE_PIP_PRODUCTS_SUCCESS: 'READ_LABOR_ADDITIVE_PIP_PRODUCTS_SUCCESS',
    READ_LABOR_ADDITIVE_PIP_PRODUCTS_SUMMARIES_SUCCESS: 'READ_LABOR_ADDITIVE_PIP_PRODUCTS_SUMMARIES_SUCCESS',
    READ_METRICS_SUCCESS: 'READ_METRICS_SUCCESS',
    READ_OPEN_PIP_PRODUCTS_SUCCESS: 'READ_OPEN_PIP_PRODUCTS_SUCCESS',
    READ_OPEN_PIP_PRODUCTS_SUMMARY_SUCCESS: 'READ_OPEN_PIP_PRODUCTS_SUMMARY_SUCCESS',
    READ_PIP_CODE_TYPE_SUCCESS: 'READ_PIP_CODE_TYPE_SUCCESS',
    READ_PIP_DETAILS: 'READ_PIP_DETAILS',
    READ_PIP_DETAILS_SUCCESS: 'READ_PIP_DETAILS_SUCCESS',
    READ_PIP_PRODUCTS: 'READ_PIP_PRODUCTS',
    READ_PIP_PRODUCT_SUCCESS: 'READ_PIP_PRODUCT_SUCCESS',
    READ_PIP_SEARCH_PIP_METRICS_SUCCESS: 'READ_PIP_SEARCH_PIP_METRICS_SUCCESS',
    READ_PIP_SEARCH_PIP_TYPES_SUCCESS: 'READ_PIP_SEARCH_PIP_TYPES_SUCCESS',
    READ_PIP_TYPES_SUCCESS: 'READ_PIP_TYPES_SUCCESS',
    READ_SHOW_EXCLUDED_SUCCESS: 'READ_SHOW_EXCLUDED_SUCCESS',
    RESET_LABOR_ADDITIVE_PIP_PRODUCTS_FILTERS: 'RESET_LABOR_ADDITIVE_PIP_PRODUCTS_FILTERS',
    RESET_OPEN_PIP_PRODUCTS_FILTERS: 'RESET_OPEN_PIP_PRODUCTS_FILTERS',
    RESET_OPEN_PIP_PRODUCTS_TEXT_FILTER: 'RESET_OPEN_PIP_PRODUCTS_TEXT_FILTER',
    RESET_PIP_CODE: 'RESET_PIP_CODE',
    RESET_PIP_CODE_REQUEST_CUSTOMER_STATE: 'RESET_PIP_CODE_REQUEST_CUSTOMER_STATE',
    RESET_PIP_CODE_REQUEST_PIP_PRODUCT: 'RESET_PIP_CODE_REQUEST_PIP_PRODUCT',
    RESET_PIP_DETAILS: 'RESET_PIP_DETAILS',
    RESET_PIP_SEARCH_FILTERS: 'RESET_PIP_SEARCH_FILTERS',
    SELECT_ALL_OPEN_PIP_PRODUCTS_DEALER_ACCOUNT_FACET_ITEMS: 'SELECT_ALL_OPEN_PIP_PRODUCTS_DEALER_ACCOUNT_FACET_ITEMS',
    SELECT_ALL_PIP_SEARCH_DEALER_ACCOUNT_FACET_ITEMS: 'SELECT_ALL_PIP_SEARCH_DEALER_ACCOUNT_FACET_ITEMS',
    TOGGLE_LABOR_ADDITIVE_PIP_PRODUCTS_DEALER_ACCOUNT_FACET_ITEMS: 'TOGGLE_LABOR_ADDITIVE_PIP_PRODUCTS_DEALER_ACCOUNT_FACET_ITEMS',
    TOGGLE_OPEN_PIP_PRODUCTS_DEALER_ACCOUNT_FACET_ITEMS: 'TOGGLE_OPEN_PIP_PRODUCTS_DEALER_ACCOUNT_FACET_ITEMS',
    TOGGLE_OPEN_PIP_PRODUCTS_METRICS_FACET_ITEMS: 'TOGGLE_OPEN_PIP_PRODUCTS_METRICS_FACET_ITEMS',
    TOGGLE_OPEN_PIP_PRODUCTS_PIP_TYPE_FACET_ITEMS: 'TOGGLE_OPEN_PIP_PRODUCTS_PIP_TYPE_FACET_ITEMS',
    TOGGLE_OPEN_PIP_REPORTS_ACCORDION: 'TOGGLE_OPEN_PIP_REPORTS_ACCORDION',
    TOGGLE_PIP_SEARCH_DEALER_ACCOUNT_FACET_ITEMS: 'TOGGLE_PIP_SEARCH_DEALER_ACCOUNT_FACET_ITEMS',
    TOGGLE_PIP_SEARCH_PIP_TYPE_FACET_ITEMS: 'TOGGLE_PIP_SEARCH_PIP_TYPE_FACET_ITEMS',
    UPDATE_FORM_VALIDATION_STATE: 'UPDATE_FORM_VALIDATION_STATE',
    UPDATE_LABOR_ADDITIVE_PIP_PRODUCTS_DEALER_ACCOUNT_FACET_INPUT: 'UPDATE_LABOR_ADDITIVE_PIP_PRODUCTS_DEALER_ACCOUNT_FACET_INPUT',
    UPDATE_LABOR_ADDITIVE_PIP_PRODUCTS_DEALER_ACCOUNT_FACET_ITEM: 'UPDATE_LABOR_ADDITIVE_PIP_PRODUCTS_DEALER_ACCOUNT_FACET_ITEM',
    UPDATE_LABOR_ADDITIVE_PIP_PRODUCTS_FILTERED: 'UPDATE_LABOR_ADDITIVE_PIP_PRODUCTS_FILTERED',
    UPDATE_LABOR_ADDITIVE_PIP_PRODUCTS_FILTER_BY: 'UPDATE_LABOR_ADDITIVE_PIP_PRODUCTS_FILTER_BY',
    UPDATE_LABOR_ADDITIVE_PIP_PRODUCTS_SHOW_EXCLUDED_FACET_ITEM: 'UPDATE_LABOR_ADDITIVE_PIP_PRODUCTS_SHOW_EXCLUDED_FACET_ITEM',
    UPDATE_LABOR_ADDITIVE_PIP_PRODUCTS_SORT_BY: 'UPDATE_LABOR_ADDITIVE_PIP_PRODUCTS_SORT_BY',
    UPDATE_LABOR_ADDITIVE_PIP_PRODUCTS_SORT_DIRECTION: 'UPDATE_LABOR_ADDITIVE_PIP_PRODUCTS_SORT_DIRECTION',
    UPDATE_LABOR_ADDITIVE_PIP_PRODUCTS_SUMMARY: 'UPDATE_LABOR_ADDITIVE_PIP_PRODUCTS_SUMMARY',
    UPDATE_LABOR_ADDITIVE_PIP_PRODUCTS_SUMMARY_MODAL_VISIBILITY: 'UPDATE_LABOR_ADDITIVE_PIP_PRODUCTS_SUMMARY_MODAL_VISIBILITY',
    UPDATE_OPEN_PIP_PRODUCTS_DEALER_ACCOUNT_FACET_INPUT: 'UPDATE_OPEN_PIP_PRODUCTS_DEALER_ACCOUNT_FACET_INPUT',
    UPDATE_OPEN_PIP_PRODUCTS_DEALER_ACCOUNT_FACET_ITEM: 'UPDATE_OPEN_PIP_PRODUCTS_DEALER_ACCOUNT_FACET_ITEM',
    UPDATE_OPEN_PIP_PRODUCTS_FILTERED: 'UPDATE_OPEN_PIP_PRODUCTS_FILTERED',
    UPDATE_OPEN_PIP_PRODUCTS_FILTER_BY: 'UPDATE_OPEN_PIP_PRODUCTS_FILTER_BY',
    UPDATE_OPEN_PIP_PRODUCTS_METRIC_FACET_ITEM: 'UPDATE_OPEN_PIP_PRODUCTS_METRIC_FACET_ITEM',
    UPDATE_OPEN_PIP_PRODUCTS_PIP_TYPE_FACET_ITEM: 'UPDATE_OPEN_PIP_PRODUCTS_PIP_TYPE_FACET_ITEM',
    UPDATE_OPEN_PIP_PRODUCTS_SORT_BY: 'UPDATE_OPEN_PIP_PRODUCTS_SORT_BY',
    UPDATE_OPEN_PIP_PRODUCTS_SORT_DIRECTION: 'UPDATE_OPEN_PIP_PRODUCTS_SORT_DIRECTION',
    UPDATE_PIP_CODE_FILE_LIST: 'UPDATE_PIP_CODE_FILE_LIST',
    UPDATE_PIP_CODE_FORM_VISIBILITY: 'UPDATE_PIP_CODE_FORM_VISIBILITY',
    UPDATE_PIP_CODE_OBJECT: 'UPDATE_PIP_CODE_OBJECT',
    UPDATE_PIP_HAS_SEARCH_RESULTS: 'UPDATE_PIP_HAS_SEARCH_RESULTS',
    UPDATE_PIP_SEARCH_BY: 'UPDATE_PIP_SEARCH_BY',
    UPDATE_PIP_SEARCH_BY_TYPE: 'UPDATE_PIP_SEARCH_BY_TYPE',
    UPDATE_PIP_SEARCH_DEALER_ACCOUNT_FACET_ITEM: 'UPDATE_PIP_SEARCH_DEALER_ACCOUNT_FACET_ITEM',
    UPDATE_PIP_SEARCH_IS_VALID_DEALER: 'UPDATE_PIP_SEARCH_IS_VALID_DEALER',
    UPDATE_PIP_SEARCH_METRIC_FACET_ITEM: 'UPDATE_PIP_SEARCH_METRIC_FACET_ITEM',
    UPDATE_PIP_SEARCH_PIP_TYPE_FACET_ITEM: 'UPDATE_PIP_SEARCH_PIP_TYPE_FACET_ITEM',
    UPDATE_PIP_SEARCH_QUERY_STRING: 'UPDATE_PIP_SEARCH_QUERY_STRING',
    UPDATE_PIP_SEARCH_RESULTS_SUCCESS: 'UPDATE_PIP_SEARCH_RESULTS_SUCCESS',
    UPDATE_SHOW_MORE_GROUPS_VISIBILITY: 'UPDATE_SHOW_MORE_GROUPS_VISIBILITY'
});



// WEBPACK FOOTER //
// ./src/pip/actions-list.js